/**
 * @description Max date of prior year. 
 * @returns number - last year
 */
export const maxDate = () => {
  const year = new Date().getFullYear() - 1;
  
  return `${year.toString()}-12-31`;
};
